module.exports = __webpack_public_path__ + "img/pause-button.a16dd238.svg";